(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sf-spotlight-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-spotlight-banners-v2')) {
    customElements.define('sf-spotlight-banners-v2', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.animationFrame);
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.settleTimer);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.track?.querySelectorAll('[data-sf-clone]').forEach((card) => card.remove());
        this.cards?.forEach((card) => this.setCardAccessible(card, true));
        this.events = null;
        this.gesture = null;
        this.animating = false;
        this.track?.classList.remove('is-dragging');
        this.allCards = null;
        this.positions = null;
        this.looping = undefined;
        this.classList.remove('is-ready');
        this.removeAttribute('data-sf-input-ready');
      }

      initialize() {
        if (!this.isConnected || this.events) return;
        this.track = this.querySelector('.sf-spotlight__track');
        this.cards = [...this.querySelectorAll('.sf-spotlight__card:not([data-sf-clone])')];
        if (!this.track || !this.cards.length) return;
        this.navigation = this.querySelector('.sf-spotlight__navigation');
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.status = this.querySelector('.sf-spotlight__status');
        this.playback = this.querySelector('[data-playback]');
        this.desktopQuery = matchMedia('(min-width: 768px)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motionQuery.matches;
        this.hovered = false;
        this.ignoreHover = false;
        this.pointerActive = false;
        this.animating = false;
        this.gesture = null;
        this.suppressClickUntil = 0;
        this.usesTouchEvents = 'ontouchstart' in window;
        this.lastTouchAt = -Infinity;
        this.scrolling = false;
        this.inView = false;
        this.ended = false;
        this.currentIndex = 0;
        this.designMode = this.dataset.designMode === 'true';
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.cards.forEach((card, index) => { card.dataset.sfIndex = index; });

        this.addEventListener('click', (event) => {
          if (performance.now() < this.suppressClickUntil && this.track.contains(event.target)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-playback]') === this.playback) {
            this.togglePlayback();
            return;
          }
          const arrow = event.target.closest('[data-direction]');
          if (!arrow || !this.contains(arrow) || arrow.disabled) return;
          this.manualInteraction();
          this.advance(Number(arrow.dataset.direction));
        }, options);

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.scheduleAutoplay();
        }, options);
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.ignoreHover = false;
          this.scheduleAutoplay();
        }, options);
        this.addEventListener('focusin', (event) => {
          if (event.target !== this.playback && event.target.matches(':focus-visible')) this.userPaused = true;
          this.scheduleAutoplay();
        }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => { if (this.events) this.scheduleAutoplay(); });
        }, options);

        this.track.addEventListener('touchstart', (event) => this.beginTouch(event), { ...options, capture: true, passive: true });
        document.addEventListener('touchmove', (event) => this.moveTouch(event), { ...options, capture: true, passive: false });
        document.addEventListener('touchend', (event) => this.endTouch(event), { ...options, capture: true, passive: true });
        document.addEventListener('touchcancel', (event) => this.endTouch(event, true), { ...options, capture: true, passive: true });
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch' && this.usesTouchEvents) return;
          if (event.pointerType === 'mouse' && performance.now() - this.lastTouchAt < 800) return;
          this.beginGesture(event);
        }, { ...options, passive: true });
        document.addEventListener('pointermove', (event) => {
          if (this.gesture?.source === 'pointer') this.moveGesture(event);
        }, { ...options, capture: true, passive: false });
        document.addEventListener('pointerup', (event) => {
          if (this.gesture?.source === 'pointer') this.endGesture(event);
        }, { ...options, capture: true, passive: true });
        document.addEventListener('pointercancel', (event) => {
          if (this.gesture?.source === 'pointer') this.endGesture(event, true);
        }, { ...options, capture: true, passive: true });
        this.track.addEventListener('lostpointercapture', (event) => {
          if (this.gesture?.source === 'pointer' && event.target === this.track && !this.track.hasPointerCapture(event.pointerId)) {
            this.endGesture(event, true);
          }
        }, options);
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        window.addEventListener('blur', () => this.endGesture(null, true), options);
        this.track.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) > 0 || event.shiftKey) {
            this.cancelAnimation();
            this.manualInteraction();
          }
        }, { ...options, passive: true });
        this.track.addEventListener('scroll', () => {
          this.scrolling = true;
          clearTimeout(this.autoplayTimer);
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
          this.queueSettle();
        }, { ...options, passive: true });
        this.track.addEventListener('scrollend', () => this.finishScroll(), options);
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !this.canScroll) return;
          let direction = 0;
          if (event.key === 'ArrowRight') direction = this.rtl ? -1 : 1;
          else if (event.key === 'ArrowLeft') direction = this.rtl ? 1 : -1;
          else if (event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          this.manualInteraction();
          if (direction) this.advance(direction);
          else this.goToLogical(event.key === 'Home' ? 0 : this.lastIndex);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.userPaused = true;
          this.goToLogical(index, 'instant');
        }, options);
        document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), options);
        window.addEventListener('pagehide', () => clearTimeout(this.autoplayTimer), options);
        window.addEventListener('pageshow', () => this.scheduleAutoplay(), options);
        this.desktopQuery.addEventListener('change', () => this.measure(), options);
        this.motionQuery.addEventListener('change', () => {
          if (this.motionQuery.matches) this.userPaused = true;
          this.scheduleAutoplay();
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          this.scheduleAutoplay();
        }, { threshold: [0, 0.2] });
        this.intersectionObserver.observe(this.track);
        this.classList.add('is-ready');
        this.setAttribute('data-sf-input-ready', 'true');
        this.measure();
      }

      get autoplayEnabled() {
        return (this.desktopQuery.matches ? this.dataset.autoplayDesktop : this.dataset.autoplayMobile) === 'true';
      }

      get lastIndex() {
        return this.looping ? this.cards.length - 1 : Math.max(0, this.cards.length - this.columns);
      }

      cloneCard(card) {
        const clone = card.cloneNode(true);
        clone.dataset.sfClone = 'true';
        clone.removeAttribute('data-block-id');
        [clone, ...clone.querySelectorAll('*')].forEach((node) => {
          node.removeAttribute('id');
          [...node.attributes].forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify-editor')) node.removeAttribute(attribute.name);
          });
        });
        this.setCardAccessible(clone, false);
        return clone;
      }

      measure() {
        if (!this.events || this.track.clientWidth < 1) return;
        this.cancelAnimation();
        this.gesture = null;
        this.pointerActive = false;
        this.track.classList.remove('is-dragging');
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.settleTimer);
        const logical = this.currentIndex || 0;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.columns = Math.min(this.cards.length, Math.max(1, Math.round(parseFloat(getComputedStyle(this).getPropertyValue('--sf-columns')) || 1)));
        this.canScroll = this.cards.length > this.columns;
        const looping = this.dataset.loop === 'true' && this.canScroll;
        if (this.looping !== looping || !this.allCards) {
          this.track.querySelectorAll('[data-sf-clone]').forEach((card) => card.remove());
          this.looping = looping;
          if (this.looping) {
            const before = document.createDocumentFragment();
            const after = document.createDocumentFragment();
            this.cards.forEach((card) => {
              before.append(this.cloneCard(card));
              after.append(this.cloneCard(card));
            });
            this.track.prepend(before);
            this.track.append(after);
          }
          this.allCards = [...this.track.querySelectorAll('.sf-spotlight__card')];
        }
        this.measuredWidth = this.track.clientWidth;
        this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const trackBounds = this.track.getBoundingClientRect();
        const offset = this.scrollPosition();
        this.positions = this.allCards.map((card) => {
          const bounds = card.getBoundingClientRect();
          const delta = this.rtl ? trackBounds.right - bounds.right : bounds.left - trackBounds.left;
          return Math.max(0, Math.min(this.maximum, offset + delta));
        });
        this.currentIndex = Math.min(logical, this.lastIndex);
        const physical = this.currentIndex + (this.looping ? this.cards.length : 0);
        this.scrollToPosition(this.positions[physical], 'instant');
        this.scrolling = false;
        this.ended = !this.looping && this.canScroll && this.currentIndex >= this.lastIndex;
        this.update();
        this.updateAccessibility();
        this.scheduleAutoplay();
      }

      scrollPosition() {
        return Math.min(this.maximum || this.track.scrollWidth, Math.max(0, Math.abs(this.track.scrollLeft)));
      }

      closestPhysical() {
        const current = this.scrollPosition();
        return this.positions.reduce((closest, value, index) =>
          Math.abs(value - current) < Math.abs(this.positions[closest] - current) ? index : closest, 0);
      }

      logicalIndex(physical) {
        if (!this.looping) return Math.min(physical, this.lastIndex);
        const count = this.cards.length;
        return ((physical - count) % count + count) % count;
      }

      update() {
        if (!this.positions?.length) return;
        if (this.measuredWidth !== this.track.clientWidth) {
          this.measure();
          return;
        }
        this.currentIndex = this.logicalIndex(this.closestPhysical());
        if (this.previous) this.previous.disabled = !this.canScroll || (!this.looping && this.currentIndex === 0);
        if (this.next) this.next.disabled = !this.canScroll || (!this.looping && this.currentIndex === this.lastIndex);
        if (this.status) {
          const label = `${this.currentIndex + 1} / ${this.lastIndex + 1}`;
          if (this.status.textContent !== label) this.status.textContent = label;
        }
      }

      setCardAccessible(card, visible) {
        if (visible) card.removeAttribute('aria-hidden');
        else card.setAttribute('aria-hidden', 'true');
        card.setAttribute('aria-setsize', this.cards.length);
        card.setAttribute('aria-posinset', Number(card.dataset.sfIndex) + 1);
        card.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          if (!element.hasAttribute('data-sf-tabindex')) {
            element.dataset.sfTabindex = element.getAttribute('tabindex') ?? 'none';
          }
          if (!visible) element.setAttribute('tabindex', '-1');
          else if (element.dataset.sfTabindex === 'none') element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', element.dataset.sfTabindex);
        });
      }

      updateAccessibility() {
        const bounds = this.track.getBoundingClientRect();
        this.allCards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          const visible = Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > rect.width / 2;
          this.setCardAccessible(card, visible);
        });
      }

      queueSettle() {
        clearTimeout(this.settleTimer);
        if (this.pointerActive || this.animating) return;
        this.settleTimer = setTimeout(() => this.finishScroll(), 160);
      }

      finishScroll() {
        if (!this.events || this.pointerActive || this.animating) return;
        clearTimeout(this.settleTimer);
        this.scrolling = false;
        this.update();
        const nearest = this.closestPhysical();
        if (Math.abs(this.scrollPosition() - this.positions[nearest]) > 1) {
          this.moveToPhysical(nearest);
          return;
        }
        if (this.looping) {
          const physical = nearest;
          const canonical = this.cards.length + this.currentIndex;
          if (physical !== canonical) {
            const focused = document.activeElement;
            const focusedCard = focused?.closest('.sf-spotlight__card');
            const focusedIndex = focusedCard && this.track.contains(focusedCard) ? Number(focusedCard.dataset.sfIndex) : -1;
            const linkIndex = focusedIndex >= 0 ? [...focusedCard.querySelectorAll('a,button')].indexOf(focused) : -1;
            this.scrollToPosition(this.positions[canonical], 'instant');
            this.updateAccessibility();
            if (linkIndex >= 0) {
              const equivalent = this.allCards.find((card) => Number(card.dataset.sfIndex) === focusedIndex && !card.hasAttribute('aria-hidden'));
              equivalent?.querySelectorAll('a,button')[linkIndex]?.focus({ preventScroll: true });
            }
          }
        }
        this.ended = !this.looping && this.canScroll && this.currentIndex >= this.lastIndex;
        this.updateAccessibility();
        this.scheduleAutoplay();
      }

      manualInteraction() {
        clearTimeout(this.autoplayTimer);
        if (this.dataset.stopOnInteraction !== 'false') this.userPaused = true;
        this.renderPlayback();
      }

      advance(direction) {
        if (!this.canScroll) return;
        this.cancelAnimation();
        let physical = this.closestPhysical();
        if (this.looping) {
          const canonical = this.cards.length + this.logicalIndex(physical);
          if (physical !== canonical) {
            this.scrollToPosition(this.positions[canonical], 'instant');
            physical = canonical;
          }
        }
        const target = this.looping ? physical + direction : Math.max(0, Math.min(physical + direction, this.lastIndex));
        this.moveToPhysical(target);
      }

      goToLogical(index, behavior) {
        const logical = Math.max(0, Math.min(index, this.lastIndex));
        this.moveToPhysical(logical + (this.looping ? this.cards.length : 0), behavior);
      }

      cancelAnimation() {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.animating = false;
      }

      loopPosition(position) {
        if (!this.looping) return Math.max(0, Math.min(position, this.maximum));
        const start = this.positions[this.cards.length];
        const period = this.positions[this.cards.length * 2] - start;
        if (period <= 0) return position;
        return start + ((position - start) % period + period) % period;
      }

      touchPoint(touch, event) {
        return {
          source: 'touch',
          pointerType: 'touch',
          pointerId: `touch-${touch.identifier}`,
          isPrimary: true,
          button: 0,
          clientX: touch.clientX,
          clientY: touch.clientY,
          cancelable: event.cancelable,
          preventDefault: () => event.preventDefault()
        };
      }

      beginTouch(event) {
        this.usesTouchEvents = true;
        this.lastTouchAt = performance.now();
        if (event.touches.length !== 1) {
          if (this.gesture) this.endGesture(null, true);
          return;
        }
        if (this.gesture?.source === 'pointer') this.endGesture(null, true);
        this.beginGesture(this.touchPoint(event.touches[0], event));
      }

      moveTouch(event) {
        if (this.gesture?.source !== 'touch') return;
        if (event.touches.length !== 1) {
          this.endGesture(null, true);
          return;
        }
        const touch = Array.from(event.touches).find((point) => `touch-${point.identifier}` === this.gesture.id);
        if (touch) this.moveGesture(this.touchPoint(touch, event));
      }

      endTouch(event, cancelled = false) {
        if (this.gesture?.source !== 'touch') return;
        const touch = Array.from(event.changedTouches).find((point) => `touch-${point.identifier}` === this.gesture.id);
        if (!touch && event.touches.length) return;
        this.lastTouchAt = performance.now();
        this.endGesture(touch ? this.touchPoint(touch, event) : null, cancelled);
      }

      beginGesture(event) {
        if (!this.canScroll || event.isPrimary === false || this.gesture) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.cancelAnimation();
        clearTimeout(this.settleTimer);
        clearTimeout(this.autoplayTimer);
        this.suppressClickUntil = 0;
        this.scrollToPosition(this.loopPosition(this.scrollPosition()));
        this.update();
        this.pointerActive = true;
        this.gesture = {
          source: event.source || 'pointer',
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startPosition: this.scrollPosition(),
          startIndex: this.currentIndex,
          distance: 0,
          axis: null
        };
      }

      moveGesture(event) {
        const gesture = this.gesture;
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.startX;
        const dy = event.clientY - gesture.startY;
        if (!gesture.axis) {
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
          gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (gesture.axis === 'x') {
            this.manualInteraction();
            if (gesture.source === 'pointer') {
              try { this.track.setPointerCapture(event.pointerId); } catch (error) {}
            }
            this.track.classList.add('is-dragging');
          }
        }
        if (gesture.axis !== 'x') return;
        if (event.cancelable) event.preventDefault();
        gesture.distance = -dx * (this.rtl ? -1 : 1);
        this.scrolling = true;
        this.scrollToPosition(this.loopPosition(gesture.startPosition + gesture.distance));
        this.update();
      }

      endGesture(event, cancelled = false) {
        const gesture = this.gesture;
        if (!gesture || (event && event.pointerId !== gesture.id)) return;
        this.gesture = null;
        this.pointerActive = false;
        this.track.classList.remove('is-dragging');
        if (gesture.source === 'pointer' && this.track.hasPointerCapture(gesture.id)) this.track.releasePointerCapture(gesture.id);
        if (gesture.axis !== 'x') {
          this.queueSettle();
          return;
        }
        this.suppressClickUntil = performance.now() + 450;
        let target = this.closestPhysical();
        const width = this.cards[0].getBoundingClientRect().width;
        const threshold = Math.min(60, width * 0.18);
        if (!cancelled && Math.abs(gesture.distance) >= threshold && this.logicalIndex(target) === gesture.startIndex) {
          target += Math.sign(gesture.distance);
        }
        target = Math.max(0, Math.min(target, this.looping ? this.positions.length - 1 : this.lastIndex));
        this.moveToPhysical(target);
      }

      moveToPhysical(index, behavior) {
        const target = this.positions[index];
        if (!Number.isFinite(target)) return;
        this.cancelAnimation();
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.settleTimer);
        const start = this.scrollPosition();
        const difference = target - start;
        if (behavior === 'instant' || this.motionQuery.matches || Math.abs(difference) < 1) {
          this.scrollToPosition(target);
          this.finishScroll();
          return;
        }
        this.scrolling = true;
        this.animating = true;
        const started = performance.now();
        const duration = 280;
        const tick = (now) => {
          if (!this.events || !this.isConnected) return;
          const progress = Math.min(1, (now - started) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.scrollToPosition(start + difference * eased);
          this.update();
          if (progress < 1) this.animationFrame = requestAnimationFrame(tick);
          else {
            this.animationFrame = null;
            this.animating = false;
            this.scrollToPosition(target);
            this.finishScroll();
          }
        };
        this.animationFrame = requestAnimationFrame(tick);
      }

      scrollToPosition(position) {
        if (!Number.isFinite(position)) return;
        this.track.scrollLeft = this.rtl ? -position : position;
      }

      togglePlayback() {
        if (!this.autoplayEnabled || !this.canScroll || this.designMode) return;
        if (!this.userPaused && !this.ended) this.userPaused = true;
        else {
          this.userPaused = false;
          this.ignoreHover = true;
          if (this.ended) {
            this.ended = false;
            this.goToLogical(0);
          }
        }
        this.scheduleAutoplay();
      }

      renderPlayback() {
        const showPlayback = this.canScroll && this.autoplayEnabled && !this.designMode;
        this.playback.hidden = !showPlayback;
        this.navigation.hidden = !this.canScroll || (!this.previous && !showPlayback);
        const paused = this.userPaused || this.ended;
        this.playback.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
        this.playback.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
        const label = paused ? this.playback.dataset.playLabel : this.playback.dataset.pauseLabel;
        this.playback.querySelector('[data-playback-label]').textContent = label;
        this.playback.setAttribute('aria-label', label);
        if (this.status) this.status.setAttribute('aria-live', this.autoplayEnabled && !paused && !this.designMode ? 'off' : 'polite');
      }

      scheduleAutoplay() {
        clearTimeout(this.autoplayTimer);
        if (!this.events) return;
        this.renderPlayback();
        const active = document.activeElement;
        const hasContentFocus = this.contains(active) && active !== this.playback && active.matches(':focus-visible');
        if (!this.autoplayEnabled || !this.canScroll || this.userPaused || this.ended || this.designMode ||
            !this.inView || document.hidden || this.pointerActive || this.scrolling || hasContentFocus ||
            (this.hovered && !this.ignoreHover)) return;
        const delay = Math.max(3000, Math.min(15000, Number(this.dataset.autoplayDelay) || 6000));
        this.autoplayTimer = setTimeout(() => this.advance(1), delay);
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
